import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./sideNav.css";
const common = require("../utils/Common");

const SideNav = ({ collapsed, setCollapsed }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = React.useState(null);

  const logOut = async () => {
    if (localStorage.getItem("admin_token")) {
      let data = { access_token: localStorage.getItem("admin_token") };
      let response = await common.apiRequest("post", "/admin/logout", data);
      if (response.status === 200 && response.data.code === "success") {
        localStorage.removeItem("admin_token");
        localStorage.removeItem("admin_userId");
        sessionStorage.removeItem("access_rights");
        alert(response.data.message);
      }
    }
    navigate("/login");
  };

  const toggleSubMenu = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };

  return (
    <div className={`sidebar${collapsed ? " collapsed" : ""}`}>
      <div className="sidebar-header">
        <span>{!collapsed && "Admin Panel"}</span>
        <button className="sidebar-toggle-btn" onClick={() => setCollapsed(!collapsed)}>
          ☰
        </button>
      </div>

      <ul>
        {/* Main Links */}
        <li className={location.pathname === "/" ? "active" : ""}>
          <Link to="/">🏠 {!collapsed && "Home"}</Link>
        </li>
        <li className={location.pathname === "/service" ? "active" : ""}>
          <Link to="/service">🛠 {!collapsed && "Service"}</Link>
        </li>
        <li className={location.pathname === "/category" ? "active" : ""}>
          <Link to="/category">📂 {!collapsed && "Category"}</Link>
        </li>
        <li className={location.pathname === "/Srrr-report" ? "active" : ""}>
          <Link to="/Srrr-report">📑 {!collapsed && "SRRR Report"}</Link>
        </li>

        {/* Admin Links Dropdown */}
        <li onClick={() => toggleSubMenu("admin")}>
          ⚙️ {!collapsed && "Admin Links ▼"}
        </li>
        <div className={`submenu${openMenu === "admin" ? " open" : ""}`}>
          {/* <li><Link to="/">🏠 {!collapsed && "Home"}</Link></li>
          <li><Link to="/category">📂 {!collapsed && "Category"}</Link></li> */}
          <li><Link to="/cms">📜 {!collapsed && "Policy Management System"}</Link></li>
          <li><Link to="/service">🛠 {!collapsed && "Service"}</Link></li>
          <li><Link to="/portals">🌐 {!collapsed && "Add Portals"}</Link></li>
          <li><Link to="/user-types">👥 {!collapsed && "Add User Types"}</Link></li>
          <li><Link to="/admin-user-creation">🧑‍💼 {!collapsed && "Admin User Creations"}</Link></li>
          {/* <li><Link to="/sellers-products">Approve Product</Link></li> */}
          <li><Link to="/discount-apply">🎯 {!collapsed && "Apply Discount"}</Link></li>
          <li><Link to="/system-config">⚙ {!collapsed && "System Config"}</Link></li>
          <li><Link to="/email-templates">✉ {!collapsed && "Email Templates"}</Link></li>
          <li><Link to="/user-feedback">💬 {!collapsed && "Feedback"}</Link></li>
          <li><Link to="/user-query">❓ {!collapsed && "Query"}</Link></li>
          {/* <li><Link to="/seller-service-approve">Seller Service Approve</Link></li> */}
          <li><Link to="/buyer-commissions">💵 {!collapsed && "Buyer Commissions"}</Link></li>
          <li><Link to="/seller-payments">💰 {!collapsed && "Seller Payments"}</Link></li>
          <li><Link to="/Buyers">🛒 {!collapsed && "Buyers"}</Link></li>
          <li><Link to="/Sellers">🏪 {!collapsed && "Sellers"}</Link></li>
          <li><Link to="/pincodes">📍 {!collapsed && "Pincodes"}</Link></li>
          <li><Link to="/wallet">👛 {!collapsed && "Wallet"}</Link></li>
          <li><Link to="/chatbot-queries">🤖 {!collapsed && "Chatbot Queries"}</Link></li>
        </div>

        {/* Reports Dropdown */}
        <li onClick={() => toggleSubMenu("reports")}>
          📊 {!collapsed && "Reports ▼"}
        </li>
        <div className={`submenu${openMenu === "reports" ? " open" : ""}`}>
          {/* <li><Link to="/">🏠 {!collapsed && "Home"}</Link></li> */}
          <li><Link to="/BankReports">🏦 {!collapsed && "Bank Reports"}</Link></li>
          {/* <li><Link to="/LogisticsReports">🚚 {!collapsed && "Logistics Reports"}</Link></li> */}
          <li><Link to="/PaymentReports">💳 {!collapsed && "Payment Reports"}</Link></li>
          <li><Link to="/ReceiptReports">🧾 {!collapsed && "Receipt Reports"}</Link></li>
          <li><Link to="/ServiceReports">🛠 {!collapsed && "Service Reports"}</Link></li>
          <li><Link to="/TdsReports">📈 {!collapsed && "TDS Reports"}</Link></li>
          <li><Link to="/VendorReports">🏢 {!collapsed && "Vendor Reports"}</Link></li>
        </div>
      </ul>

      {/* Logout Button */}
      <button className="logout-btn" onClick={logOut}>
        🚪 {!collapsed && "Logout"}
      </button>
    </div>
  );
};

export default SideNav;
